import { Annonceur } from './annonceur';
import { AvisDiffuseurId } from './avis-diffuseur-id';
import { StatutFluxEnum } from './enums/statut-flux.enum';
import { FluxBoamp } from './flux-boamp';

export class Flux {
    public id: AvisDiffuseurId;
    public dateEmission: Date;
    public dateReception: Date;
    public dateCreation: Date;
    public statut: StatutFluxEnum;
    public delaiAttente: Number;
    public annonceur: Annonceur;
    public fluxBoamp: FluxBoamp;
    // public fluxShal: FluxShal;

    constructor(){
        this.id = new AvisDiffuseurId();
        this.annonceur = new Annonceur();
    }
}
